interface DebugHighlighterProps {
  precondition: boolean;
  tooltip?: string;
  isTextContent?: boolean;
}

export const DebugHighlighter: FCC<DebugHighlighterProps> = ({
  precondition,
  tooltip,
  children,
  isTextContent,
}) => {
  const isDebug = localStorage.getItem('isDebug');

  if (isDebug !== 'true') {
    return children;
  }

  if (isTextContent) {
    return (
      <span className={precondition ? 'underline decoration-dashed' : ''} title={tooltip}>
        {children}
      </span>
    );
  }
  return (
    <div className={precondition ? 'bg-white' : ''} title={tooltip}>
      {children}
    </div>
  );
};
